"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", _vm._b({
    attrs: {
      width: !!_vm.size ? _vm.sizeMap[_vm.size] : _vm.width,
      "mask-closable": _vm.spinning ? false : _vm.maskClosable
    },
    on: {
      cancel: _vm.handleCancel
    },
    scopedSlots: _vm._u([{
      key: "closeIcon",
      fn: function () {
        return [_vm._t("closeIcon", function () {
          return [_c("basis-icon", {
            attrs: {
              type: "icon-close",
              size: "12px"
            }
          })];
        })];
      },
      proxy: true
    }, {
      key: "title",
      fn: function () {
        return [_vm._t("title")];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function () {
        return [_vm._t("footer", function () {
          return [_c("a-button", _vm._b({
            attrs: {
              disabled: _vm.spinning
            },
            on: {
              click: e => _vm.handleCancel(e)
            }
          }, "a-button", _vm.cancelButtonProps, false), [_vm._v(_vm._s(_vm.cancelText || "取消"))]), _c("a-button", _vm._b({
            attrs: {
              loading: _vm.spinning,
              type: _vm.okType
            },
            on: {
              click: e => _vm.handleOk(e)
            }
          }, "a-button", _vm.okButtonProps, false), [_vm._v(_vm._s(_vm.okText || "确定"))])];
        })];
      },
      proxy: true
    }], null, true),
    model: {
      value: _vm.localVisible,
      callback: function ($$v) {
        _vm.localVisible = $$v;
      },
      expression: "localVisible"
    }
  }, "a-modal", _vm.$props, false), [_c("a-spin", {
    attrs: {
      spinning: _vm.spinning
    }
  }, [_c("div", {
    style: "min-height:" + _vm.minHeight
  }, [_vm._t("default")], 2)])], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;